import * as React from "react"
import * as toastr from "toastr";

interface TableProps {
    data: Array<any>
    config: Array<ColumnConfigType>
    className?: string
    selectData?: any
    links?: Array<string>
}

const getValue = ({ keystone, formatter, selectDataName }: ColumnConfigType, row: any, selectData: any, key: number) => {
    if (selectData && keystone && selectData[selectDataName] && selectData[selectDataName].find(({ id }: any) => id === row[keystone])) {
        return selectData[selectDataName].find(({ id }: any) => id === row[keystone]).value
    } else if (formatter && keystone) {
        return formatter(row[keystone], key)
    } else if (keystone) {
        return row[keystone]
    } else if (formatter) {
        return formatter(row, key)
    }
}

const redirect = (link: string) => {
    if (link) {
       window.location.href = link
    }
}

const columnHeadSize = (config: any) => {

    let htmlElements: any[] = [];

    try {

        config.map(({ keystone, label }: ColumnConfigType, key: any) => {
            switch (keystone) {
                case "Ordem": htmlElements.push(<th style={{width: '5%'}} key={key}>{label || keystone}</th>); break;
                case "NomeCategoria": htmlElements.push(<th style={{width: '15%'}} key={key}>{label || keystone}</th>); break;
                case "Subenunciado": htmlElements.push(<th style={{width: '70%'}} key={key}>{label || keystone}</th>); break;
                case "Resultado": htmlElements.push(<th style={{width: '10%'}} key={key}>{label || keystone}</th>); break;
                default: htmlElements.push(<th key={key}>{label || keystone}</th>); break;
            }
        });
        
    } catch (error) {

        console.error(error);
        toastr.error("Ocorreu um erro ao carregar os títulos das colunas");
        
    }

    return htmlElements;

}

const Table = ({ data, config, className, selectData, links }: TableProps) => {

    return (
        <div className={`table-responsive ${className}`}>
            <table className="table">
                <thead>
                    <tr>
                        {columnHeadSize(config)}
                    </tr>
                </thead>
                <tbody>
                    {

                        data && data.map((row: any, key: any) => {
                            return <tr style={links ? { cursor: 'pointer' } : {}} onClick={() => redirect(links[key])} key={key} className="table-line">
                                {
                                    config.map((configColumn, key2: any) => <td className={configColumn.className} key={key2}>{getValue(configColumn, row, selectData, key)}</td>)
                                }
                            </tr>

                        })
                    }
                </tbody>
            </table>
        </div>
    )
}

export default Table